/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2025
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PanelStyle, LAND_USES } from '../../constants';
import { PersonalDataContainer } from '../../containers';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import SpecifiedAttachmentsPanel from '../../components/SpecifiedAttachmentsPanel';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import CustomizedMap from './CustomizedMap';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';
import Select from 'react-select';
import loadingData from './loading';

import v from './validators';
import s from './EServices.css';
import fetch from '../../core/fetch/fetch.server';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InitialAttachmentsDict = {
  pelnomocnictwo: {
    label: 'Pełnomocnictwo do reprezentowania składającego pismo lub pełnomocnictwo do doręczeń (zgodnie z ustawą z dnia 16 listopada 2006 r. o opłacie skarbowej (Dz. U. z 2023 r. poz. 2111)) – jeżeli składający pismo działa przez pełnomocnika.',
    required: false,
    multiple: false,
    description: '',
  },
  potwierdzenie_oplaty: {
    label: 'Potwierdzenie uiszczenia opłaty skarbowej od pełnomocnictwa – jeżeli obowiązek uiszczenia takiej opłaty wynika z ustawy z dnia 16 listopada 2006 r. o opłacie skarbowej.',
    required: false,
    multiple: false,
    description: '',
  },
  granica_terenu: {
    label: '(Nieobowiązkowo). Określenie granic terenu w formie graficznej w przypadku wskazania terenu objętego pismem jako części działki ewidencyjnej lub działek ewidencyjnych.',
    required: false,
    multiple: false,
    description: '',
  },
  inne: {
    label: '(Nieobowiązkowo). Inne załączniki – w przypadku zaznaczenia pola należy podać nazwy załączników.',
    required: false,
    multiple: true,
    description: '',
  },
};

const trescDict = {
  trescPisma: {
    label: 'Treść:',
    editable: true,
    type: 'expandedtextarea'
  },
}

const documentDetailsLabel = 'Szczegółowe informacje dotyczące treści pisma w odniesieniu do działek ewidencyjnych';
const parcelDetailsLabel = 'Szczegółowe informacje dotyczące działek ewidencyjnych oraz niektórych parametrów';

const korespondencyjnyLabel = 'Inny adres do korespondencji';
const pelnomocnikLabel = 'Pełnomocnik';
const pelnomocnikDoDorLabel = 'Pełnomocnik do doręczeń';
const oplataLabel = 'Zwolniono z opłaty';

const korespondencyjnyDict = {
  kraj: {
    label: 'Kraj',
    editable: false,
  },
  wojewodztwo: {
    label: 'Województwo',
    editable: true,
  },
  powiat: {
    label: 'Powiat',
    editable: true,
  },
  gmina: {
    label: 'Gmina',
    editable: true,
  },
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  budynek: {
    label: 'Nr budynku',
    editable: true,
  },
  lokal: {
    label: 'Nr lokalu',
    editable: true,
  },
  kod: {
    label: 'Kod pocztowy',
    editable: true,
  },
}

const agentDict = {
  agentImie: {
    label: 'Imię',
    editable: true,
  },
  agentNazwisko: {
    label: 'Nazwisko',
    editable: true,
  },
  kraj2: {
    label: 'Kraj',
    editable: false,
  },
  wojewodztwo2: {
    label: 'Województwo',
    editable: true,
  },
  powiat2: {
    label: 'Powiat',
    editable: true,
  },
  gmina2: {
    label: 'Gmina',
    editable: true,
  },
  miejscowosc2: {
    label: 'Miejscowość',
    editable: true,
  },
  ulica2: {
    label: 'Ulica',
    editable: true,
  },
  budynek2: {
    label: 'Nr budynku',
    editable: true,
  },
  lokal2: {
    label: 'Nr lokalu',
    editable: true,
  },
  kod2: {
    label: 'Kod pocztowy',
    editable: true,
  },
  email: {
    label: 'Email',
    editable: true,
  },
  telefon: {
    label: 'Telefon',
    editable: true,
  },
  epuapAddress: {
    label: 'Adres skrytki EPUAP',
    editable: true,
  },
}

const rodzajPismaOptions = [
  {
    label: 'wniosek do projektu aktu',
    value: 'wniosek',
    state: 'rodzajPisma',
  },
  {
    label: 'uwaga do konsultowanego projektu aktu',
    value: 'uwaga',
    state: 'rodzajPisma',
  },
  {
    label: 'wniosek o zmianę aktu',
    value: 'zmiana',
    state: 'rodzajPisma',
  },
  {
    label: 'wniosek o sporządzenie aktu',
    value: 'sporzadzenie',
    state: 'rodzajPisma',
  },
];

const rodzajAktuOptions = [
  {
    label: 'plan ogólny gminy',
    value: 'pog',
    state: 'rodzajAktu',
  },
  {
    label: 'miejscowy plan zagospodarowania przestrzennego, w tym zintegrowany plan inwestycyjny lub miejscowy plan rewitalizacji',
    value: 'mpzp',
    state: 'rodzajAktu',
  },
  {
    label: 'uchwała ustalająca zasady i warunki sytuowania obiektów małej architektury, tablic reklamowych i urządzeń reklamowych oraz ogrodzeń, ich gabaryty, standardy jakościowe oraz rodzaje materiałów budowlanych, z jakich mogą być wykonane',
    value: 'uchwala',
    state: 'rodzajAktu',
  },
];

const wlascicielOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'wlasciciel',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'wlasciciel',
  },
];

const korespondencjaElektronicznaOptions = [
  {
    label: 'Wyrażam zgodę',
    value: 'TAK',
    state: 'korespondencjaElektroniczna',
  },
  {
    label: 'Nie wyrażam zgody',
    value: 'NIE',
    state: 'korespondencjaElektroniczna',
  },
];

const availableLandUsesLevel1 = Object.entries(LAND_USES).map(([key, value]) => ({
  label: `${key} — ${value.description}`,
  value: key,
  state: 'nazwaKlasy1',
}));

const serviceDict = {
  WnSporzadzenieMPZP: {
    rodzajPisma: 'sporzadzenie',
    rodzajAktu: 'mpzp',
  },
  WnZmianaMPZP:  {
    rodzajPisma: 'zmiana',
    rodzajAktu: 'mpzp',
  },
}

class PismoDoAktu extends React.Component {
  state = {
    info: {
      rodzajPisma: null,
      rodzajAktu: null,
      wlasciciel: 'TAK',
      trescPisma: '',
      documentDetailsVisible: false,
      parcelDetailsVisible: false,
      korespondencjaElektroniczna: 'TAK',
    },
    adresKorespondencyjny: {
      adresKorespondencyjny: false,
      kraj: 'Polska',
      wojewodztwo: '',
      powiat: '',
      gmina: '',
      miejscowosc: '',
      ulica: '',
      budynek: '',
      lokal: '',
      kod: '',
    },
    pelnomocnik: {
      pelnomocnik: false,
      pelnomocnikDoDoreczen: false,
      agentImie: '',
      agentNazwisko: '',
      kraj2: 'Polska',
      wojewodztwo2: '',
      powiat2: '',
      gmina2: '',
      miejscowosc2: '',
      ulica2: '',
      budynek2: '',
      lokal2: '',
      kod2: '',
      telefon: '',
      email: '',
      epuapAddress: '',
      zwolnionoZOplaty: false,
    },
    attachmentsDict: InitialAttachmentsDict,
    selectedParcels: [],
    documentDetails: [],
    parcelDetails: [],
    errors: {},
    documentDetailsErrors: {},
    parcelDetailsErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    attachments: [],
    loading: false,
    isMounted: false,
    fieldTypesDisabled: false,
  };

  validators = {
    rodzajPisma: [v.NotSelected],
    rodzajAktu: [v.NotSelected],
    wlasciciel: [v.NotNull],
    trescPisma: [v.NotNull, v.MinLength(10)],
    tresc: [v.NotNull, v.MinLength(10)],
    nazwaAktu: [v.NotNull],
    korespondencjaElektroniczna: [v.NotNull],
    udzialZabudowy: [v.NotNull, v.isNumber],
    wysZabudowy: [v.NotNull, v.isNumber],
    udzialPowBiolCzynnej: [v.NotNull, v.isNumber],

    adresKorespondencyjny: [],
    wojewodztwo: [],
    powiat: [],
    gmina: [],
    miejscowosc: [],
    budynek: [],
    kod: [],

    pelnomocnik: [],
    pelnomocnikDoDoreczen: [],
    agentImie: [],
    agentNazwisko: [],
    wojewodztwo2: [],
    powiat2: [],
    gmina2: [],
    miejscowosc2: [],
    budynek2: [],
    kod2: [],
    telefon: [v.isNumber],
    email: [v.CheckEmail],
    zwolnionoZOplaty: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          isMounted: true,
        }, () => this.updateService());
      });
  }

  updateService = () => {
    const shortName = this.props.serviceInfo.eservice.shortName;
    if (shortName in serviceDict) {
      const { rodzajPisma, rodzajAktu } = serviceDict[shortName];
      this.setState({
        fieldTypesDisabled: true,
        info: {
          ...this.state.info,
          rodzajPisma,
          rodzajAktu,
        },
      }, () => this.updateValidators());
    } else {
      this.updateValidators();
    }
  }

  updateValidators = () => {
    if (this.state.adresKorespondencyjny.adresKorespondencyjny) {
      this.validators.wojewodztwo = [v.NotNull];
      this.validators.powiat = [v.NotNull];
      this.validators.gmina = [v.NotNull];
      this.validators.miejscowosc = [v.NotNull];
      this.validators.budynek = [v.NotNull];
      this.validators.kod = [v.NotNull];
    } else {
      this.validators.wojewodztwo = [];
      this.validators.powiat = [];
      this.validators.gmina = [];
      this.validators.miejscowosc = [];
      this.validators.budynek = [];
      this.validators.kod = [];
    }

    let potwierdzenie_oplatyDescription = ''
    if (this.state.pelnomocnik.pelnomocnik || this.state.pelnomocnik.pelnomocnikDoDoreczen) {
      this.validators.agentImie = [v.NotNull];
      this.validators.agentNazwisko = [v.NotNull];
      this.validators.wojewodztwo2 = [v.NotNull];
      this.validators.powiat2 = [v.NotNull];
      this.validators.gmina2 = [v.NotNull];
      this.validators.miejscowosc2 = [v.NotNull];
      this.validators.budynek2 = [v.NotNull];
      this.validators.kod2 = [v.NotNull];

      if(!this.state.pelnomocnik.zwolnionoZOplaty) {
        potwierdzenie_oplatyDescription = 
          <p style={{ color: 'red', textAlign: 'justify' }}>
            Jeśli opłaciłeś opłatę przelewem dodaj potwierdzenie uiszczenia opłaty skarbowej za pełnomocnictwo w sekcji załączników. Możesz również uiścić opłatę w dalszym kroku niniejszej e-usługi poprzez płatność online.
          </p>;
      }
    } else {
      this.validators.agentImie = [];
      this.validators.agentNazwisko = [];
      this.validators.wojewodztwo2 = [];
      this.validators.powiat2 = [];
      this.validators.gmina2 = [];
      this.validators.miejscowosc2 = [];
      this.validators.budynek2 = [];
      this.validators.kod2 = [];
    }

    const attachmentsDict = { 
      ...this.state.attachmentsDict, 
      potwierdzenie_oplaty: { 
        ...this.state.attachmentsDict.potwierdzenie_oplaty, 
        description: potwierdzenie_oplatyDescription
      } 
    };

    this.setState({attachmentsDict});

  }

  setParcels = (selectedParcels, callback = null) => {
    const documentDetails = [];
    const parcelDetails = [];
    for (const parcel of selectedParcels) {
      const documentDetail = {
        identyfikator: parcel.value,
        czyCalosc: 'TAK',
        nazwaAktu: '',
        tresc: '',
      };

      documentDetails.push(documentDetail);

      const parcelDetail = {
        identyfikator: parcel.value,
        czyCalosc: 'TAK',
        nazwaAktu: '',
        nazwaKlasy1: '',
        dostepneNazwyKlas2: [],
        nazwaKlasy2: '',
        dostepneNazwyKlas3: [],
        nazwaKlasy3: '',
        nazwyKlas: [],
        udzialZabudowy: '',
        wysZabudowy: '',
        udzialPowBiolCzynnej: '',
      };

      parcelDetails.push(parcelDetail);
    }
    this.setState({ selectedParcels, documentDetails, parcelDetails }, () => {
      this.validateDetails('documentDetailsErrors', 'documentDetails');
      this.validateDetails('parcelDetailsErrors', 'parcelDetails');
    });
  }

  onHide = () => this.setState({ showError: false });

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  };

  onIndexedChange = (e, group, field, index, errorState) => {
    const state = this.state[group];
    state[index][field] = e.target.value;
    this.setState(
      {
        [group]: state
      },
      () => this.validateDetails(errorState, group, field, index ),
    );
  };

  onChangeClass1 = (e, group, field, index) => {
    const state = this.state[group];
    state[index][field] = e.value;
    state[index].nazwaKlasy2 = '';
    state[index].nazwaKlasy3 = '';

    const dostepneNazwyKlas2 = Object.entries(LAND_USES[e.value].children).map(([key, value]) => ({
      label: `${key} — ${value.description}`,
      value: key,
      state: 'nazwaKlasy2',
    }));
    
    state[index].dostepneNazwyKlas2 = dostepneNazwyKlas2;

    this.setState({[group]: state});
  };

  onChangeClass2 = (e, group, field, index) => {
    const state = this.state[group];
    state[index][field] = e.value;
    state[index].nazwaKlasy3 = '';

    const dostepneNazwyKlas3 = Object.entries(LAND_USES[this.state[group][index].nazwaKlasy1].children[e.value].children).map(([key, value]) => ({
      label: `${key} — ${value.description}`,
      value: key,
      state: 'nazwaKlasy3',
    }));
    
    state[index].dostepneNazwyKlas3 = dostepneNazwyKlas3;

    this.setState({[group]: state});
  };

  onChangeClass3 = (e, group, field, index) => {
    const state = this.state[group];
    state[index][field] = e.value;

    this.setState({[group]: state});
  };

  addClass = (group, index) => {
    const nazwaKlasy = this.state[group][index].nazwaKlasy3 || this.state[group][index].nazwaKlasy2 || this.state[group][index].nazwaKlasy1;

    let classToAdd = '';
    if (nazwaKlasy.length == 1) {
      classToAdd = availableLandUsesLevel1.find(
        obj => obj.value === nazwaKlasy
      ).label;
    } else if (nazwaKlasy.length == 2) {
      classToAdd = this.state[group][index].dostepneNazwyKlas2.find(
        obj => obj.value === nazwaKlasy
      ).label;
    } else {
      classToAdd = this.state[group][index].dostepneNazwyKlas3.find(
        obj => obj.value === nazwaKlasy
      ).label;
    }

    const state = this.state[group];
    if (!state[index].nazwyKlas.includes(classToAdd)) {
      state[index].nazwyKlas.push(classToAdd);
    }
    
    state[index].nazwaKlasy1 = '';
    state[index].nazwaKlasy2 = '';
    state[index].nazwaKlasy3 = '';
    state[index].dostepneNazwyKlas2 = [];
    state[index].dostepneNazwyKlas3 = [];

    this.setState({ [group]: state });
  }

  removeClass = (group, index, indexToRemove) => {
    const state = this.state[group];
    const newClasses = state[index].nazwyKlas.filter((_, index) => index !== indexToRemove);
    state[index].nazwyKlas = newClasses;

    this.setState(
      {
        [group]: state
      }
    );

  }

  toggleCheckbox = (e, group, name) => {
    this.setState({
      [group]: {
        ...this.state[group],
        [name]: !this.state[group][name],
      },
    }, () => this.validate(group, name, this.updateValidators));
  };

  validateDetails = (errorState, group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateDetailField(group, field, index);
      newState = {
          ...this.state[errorState],
          [`${field}_${index}`]: checks,
      };
    } else {
      const errors = this.validateListGroups(group);
      newState = { ...errors };
    }

    if (newState) {
      this.setState({ [errorState]: newState });
    }
  };

  validateDetailField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validateDetailField(group, field, idx);
          errors[`${field}_${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info', 'pelnomocnik', 'adresKorespondencyjny'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }

    if (this.state.info.documentDetailsVisible) {
      for (const key of Object.keys(this.state.documentDetailsErrors)) {
        if (this.state.documentDetailsErrors[key].length > 0) return true;
      }
    }

    if (this.state.info.parcelDetailsVisible) {
      for (const key of Object.keys(this.state.parcelDetailsErrors)) {
        if (this.state.parcelDetailsErrors[key].length > 0) return true;
      }
    }

    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        ...this.state.info,
        wlasciciel: 'TAK',
        trescPisma: 'Testowa treść pisma',
        documentDetailsVisible: false,
        parcelDetailsVisible: false,
        korespondencjaElektroniczna: 'TAK',
      },
      adresKorespondencyjny: {
        adresKorespondencyjny: true,
        kraj: 'Polska',
        wojewodztwo: 'woj',
        powiat: 'powiat',
        gmina: 'gmina',
        miejscowosc: 'miejscowosc',
        ulica: 'ulica',
        budynek: 'budynek',
        lokal: 'lokal',
        kod: 'kod',
      },
      pelnomocnik: {
        pelnomocnik: true,
        pelnomocnikDoDoreczen: false,
        agentImie: 'imie ',
        agentNazwisko: 'nazwisko',
        kraj2: 'Polska',
        wojewodztwo2: 'woj2',
        powiat2: 'powiat2',
        gmina2: 'gmina2',
        miejscowosc2: 'miejsc2',
        ulica2: 'ulica2',
        budynek2: 'budynek2',
        lokal2: 'lokal2',
        kod2: 'kod2',
        telefon: '999999999',
        email: 'email@mail.pl',
        epuapAddress: 'epuap2',
        zwolnionoZOplaty: false,
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;  
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }
    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (this.state.info.parcelDetailsVisible) {
      for (const detail of this.state.parcelDetails) {
        if (!detail.nazwyKlas.length) {
          return this.setState({
            errorText: 'Prosimy o kompletne uzupełnienie tabeli: "Szczegółowe informacje dotyczące działek ewidencyjnych oraz niektórych parametrów" lub o odznaczenie tabeli.',
            errorTitle: 'Błędnie wypełniony formularz.',
            showError: true,
            loading: false,
          });
        }
      }
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (this.state.pelnomocnik.pelnomocnik || this.state.pelnomocnik.pelnomocnikDoDoreczen) {
      const attachmentList = this.state.attachments.filter(att => att.type === 'pelnomocnictwo');
      if (!attachmentList.length) {
        const text = <p style={{ textAlign: 'justify' }}>
          W przypadku wypełnienia danych pełnomocnika obowiązkowe jest dodanie załącznika: "Pełnomocnictwo do reprezentowania składającego pismo lub pełnomocnictwo do doręczeń (zgodnie z ustawą z dnia 16 listopada 2006 r. o opłacie skarbowej (Dz. U. z 2003 r. poz. 2111)).
        </p>
        return this.setState({
          errorText: text,
          errorTitle: 'Nie dodano załącznika.',
          showError: true,
          loading: false,
        });
      }
    }

    this.props
      .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
        dzialki: this.state.selectedParcels,
        selectedParcels: this.state.selectedParcels,
        info: this.state.info,
        adresKorespondencyjny: this.state.adresKorespondencyjny,
        pelnomocnik: this.state.pelnomocnik,
        attachments: this.state.attachments,
        documentDetails: this.state.documentDetails,
        parcelDetails: this.state.parcelDetails,
        user: {
          ...this.props.serviceInfo.user,
        },
        shortName: this.props.serviceInfo.eservice.shortName,
        urzad: this.props.districts[this.props.prefix],
      })
      .then(resp => {
        this.setState({
          loading: false }, () =>
          this.redirectToSummary(resp.jobId));
      });
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  renderRadioButtons = (buttonsList, group, state) => {
    const fieldsToDisable = ['rodzajPisma', 'rodzajAktu'];
    return (
      <div>
        {buttonsList.map((item, index) => (
          <div key={`radio${item}_${index}`} className="radio" style={{ marginBottom: '0px', marginTop: '0px' }}>
            <label
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                type="radio"
                value={item.value}
                name={state}
                checked={this.state[group][state] === item.value}
                onChange={e => this.onChange(e, group)}
                disabled={item.disabled || (fieldsToDisable.includes(state) && this.state.fieldTypesDisabled)}
              />
              <p>{`    ${item.label}`}<br /></p>
            </label>
          </div>
        ))}
        {this.renderErrorsInSpan('errors', state)}
      </div>);
  }

  renderCheckbox = (group, state, label) => {
    return (
      <div className={s.subtitle} style={{ marginTop: '10px', marginBottom: '10px' }}>
        <input
          id={`${state}Checkbox`}
          name={state}
          type="checkbox"
          checked={this.state[group][state]}
          onChange={e => this.toggleCheckbox(e, group, state)}
        />
        <label htmlFor={`${state}Checkbox`}>&nbsp;&nbsp;{label}</label>
      </div>
    )
  }

  renderDocumentDetails = () => {
    const group = 'documentDetails';
    const errorState = 'documentDetailsErrors';
    const czyCaloscField = 'czyCalosc';
    const nazwaAktuField = 'nazwaAktu';
    const trescField = 'tresc';
    return (
      <table style={{ borderSpacing: '0 10px', borderCollapse: 'separate', width: '100%', fontWeight: 'bold' }}>
        <thead>
            <tr>
                <th style={{ width: '3%' }}>Lp</th>
                <th style={{ width: '37%' }}>Identyfikator działki lub działek ewidencyjnych</th>
                <th style={{ width: '60%' }}>Czy teren objęty pismem obejmuje całość działki lub działek ewidencyjnych?</th>
            </tr>
        </thead>
        <tbody>
        {this.state[group].map((detail, index) => [
          <tr key={`${group}Row_${index}`}>
            <td key={`${group}Lp_${index}`}>{index + 1}.</td>
            <td key={`${group}Id_${index}`}>{detail.identyfikator}</td>
            <td key={`${group}${czyCaloscField}_${index}`} style={{ textAlign: 'center' }}>
              <label style={{ marginRight: '20px' }}>
                <input
                  type="radio"
                  name={`${group}${czyCaloscField}_${index}`}
                  checked={this.state[group][index][czyCaloscField] === 'TAK'}
                  onChange={e => this.onIndexedChange(e, group, czyCaloscField, index, errorState)}
                  value="TAK"
                />{' '}
                TAK
              </label>
              <label style={{ marginLeft: '10px' }}>
                <input
                  type="radio"
                  name={`${group}${czyCaloscField}_${index}`}
                  checked={this.state[group][index][czyCaloscField] === 'NIE'}
                  onChange={e => this.onIndexedChange(e, group, czyCaloscField, index, errorState)}
                  value="NIE"
                />{' '}
                NIE
              </label>
            </td>
          </tr>,
          <tr key={`${group}${nazwaAktuField}Row_${index}`}>
            <td></td>
            <td>Nazwa aktu planowania przestrzennego</td>
            <td>
              <textarea
                rows={2}
                name={`${nazwaAktuField}_${index}`}
                style={this.errorStyle(errorState, `${nazwaAktuField}_${index}`)}
                className="form-control"
                value={this.state[group][index][nazwaAktuField]}
                onChange={e => this.onIndexedChange(e, group, nazwaAktuField, index, errorState)}
                placeholder="Nazwa aktu planowania przestrzennego..."
              />
              {this.renderErrorsInSpan(errorState, `${nazwaAktuField}_${index}`)}
            </td>
          </tr>,
          <tr key={`${group}${trescField}Row_${index}`}>
            <td></td>
            <td>Treść</td>
            <td>
              <textarea
                rows={5}
                name={`${trescField}_${index}`}
                style={this.errorStyle(errorState, `${trescField}_${index}`)}
                className="form-control"
                value={this.state[group][index][trescField]}
                onChange={e => this.onIndexedChange(e, group, trescField, index, errorState)}
                placeholder="Treść..."
              />
              {this.renderErrorsInSpan(errorState, `${trescField}_${index}`)}
            </td>
          </tr>,
          
        ])}
        </tbody>
      </table>
    );
  };

  renderParcelDetails = () => {
    const group = 'parcelDetails';
    const errorState = 'parcelDetailsErrors';
    const czyCaloscField = 'czyCalosc';
    const nazwaAktuField = 'nazwaAktu';
    const klasa1Field = 'nazwaKlasy1';
    const klasa2Field = 'nazwaKlasy2';
    const klasa3Field = 'nazwaKlasy3';
    const nazwyKlasField = 'nazwyKlas';
    const udzialZabudowyField = 'udzialZabudowy';
    const wysZabudowyField = 'wysZabudowy';
    const udzialPowField = 'udzialPowBiolCzynnej';
    return (
      <table style={{ borderSpacing: '0 10px', borderCollapse: 'separate', width: '100%', fontWeight: 'bold' }}>
        <thead>
            <tr>
                <th style={{ width: '3%' }}>Lp</th>
                <th style={{ width: '37%' }}>Identyfikator działki lub działek ewidencyjnych</th>
                <th style={{ width: '60%' }}>Czy teren objęty pismem obejmuje całość działki lub działek ewidencyjnych?</th>
            </tr>
        </thead>
        <tbody>
        {this.state[group].map((detail, index) => [
          <tr key={`${group}Row_${index}`}>
            <td key={`${group}Lp_${index}`}>{index + 1}.</td>
            <td key={`${group}Id_${index}`}>{detail.identyfikator}</td>
            <td key={`${group}${czyCaloscField}_${index}`} style={{ textAlign: 'center' }}>
              <label style={{ marginRight: '20px' }}>
                <input
                  type="radio"
                  name={`${group}${czyCaloscField}_${index}`}
                  checked={this.state[group][index][czyCaloscField] === 'TAK'}
                  onChange={e => this.onIndexedChange(e, group, czyCaloscField, index, errorState)}
                  value="TAK"
                />{' '}
                TAK
              </label>
              <label style={{ marginLeft: '10px' }}>
                <input
                  type="radio"
                  name={`${group}${czyCaloscField}_${index}`}
                  checked={this.state[group][index][czyCaloscField] === 'NIE'}
                  onChange={e => this.onIndexedChange(e, group, czyCaloscField, index, errorState)}
                  value="NIE"
                />{' '}
                NIE
              </label>
            </td>
          </tr>,
          <tr key={`${group}${nazwaAktuField}Row_${index}`}>
            <td></td>
            <td>Nazwa aktu planowania przestrzennego</td>
            <td>
              <textarea
                rows={2}
                name={`${nazwaAktuField}_${index}`}
                style={this.errorStyle(errorState, `${nazwaAktuField}_${index}`)}
                className="form-control"
                value={this.state[group][index][nazwaAktuField]}
                onChange={e => this.onIndexedChange(e, group, nazwaAktuField, index, errorState)}
                placeholder="Nazwa aktu planowania przestrzennego..."
              />
              {this.renderErrorsInSpan(errorState, `${nazwaAktuField}_${index}`)}
            </td>
          </tr>,
          <tr key={`${group}${klasa1Field}Row_${index}`}>
            <td></td>
            <td>Nazwa lub nazwy klasy przeznaczenia terenu</td>
            <td>
              <Select
                placeholder="Wybierz nazwę strefy planistycznej."
                name="option"
                value={this.state[group][index][klasa1Field]}
                options={availableLandUsesLevel1}
                clearable={false}
                onChange={e => this.onChangeClass1(e, group, klasa1Field, index)}
                noResultsText={'brak wyników'}
                onBlur={event => event.preventDefault()}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />
            </td>
          </tr>,
          <tr key={`${group}${klasa2Field}Row_${index}`}>
            <td></td>
            <td></td>
            <td>
              <Select
                placeholder="Wybierz podstawowy profil funkcjonalny."
                name="option"
                value={this.state[group][index][klasa2Field]}
                options={this.state[group][index].dostepneNazwyKlas2}
                clearable={false}
                onChange={e => this.onChangeClass2(e, group, klasa2Field, index)}
                noResultsText={'brak wyników'}
                onBlur={event => event.preventDefault()}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />
            </td>
          </tr>,
          <tr key={`${group}${klasa3Field}Row_${index}`}>
            <td></td>
            <td></td>
            <td>
              <Select
                placeholder="Wybierz dodatkowy profil funkcjonalny."
                name="option"
                value={this.state[group][index][klasa3Field]}
                options={this.state[group][index].dostepneNazwyKlas3}
                clearable={false}
                onChange={e => this.onChangeClass3(e, group, klasa3Field, index)}
                noResultsText={'brak wyników'}
                onBlur={event => event.preventDefault()}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />
            </td>
          </tr>,
          <tr key={`${group}AddClassRow_${index}`}>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>
              <button
                type="submit-lg"
                className="btn btn-primary"
                style={{ ...btnStyle, padding: '6px 12px', marginLeft: '0px' }}
                onClick={() => this.addClass(group, index)}
                disabled={!this.state[group][index].nazwaKlasy1}
              >
                Dodaj klasę
              </button>
            </td>
          </tr>,
          <tr key={`${group}${nazwyKlasField}_${index}`}>
            <td></td>
            <td></td>
            <td>
            {this.state[group][index][nazwyKlasField].map((name, idx) => {
              return (
                <li
                  key={`${group}${nazwyKlasField}_${index}_${idx}`}
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p>{name}</p>
                  <button
                    className="btn btn-default"
                    onClick={() => this.removeClass(group, index, idx)}
                  >
                    <i className="fa fa-times" style={{ color: 'red' }}></i>
                  </button>
                </li>
              
            )})}
            {!this.state[group][index][nazwyKlasField].length ? 
            <p style={{ color: 'red' }}>Należy dodać co najmniej jedną klasę przeznaczenia terenu!</p>
            : null}
            </td>
          </tr>,
          <tr key={`${group}${udzialZabudowyField}Row_${index}`}>
            <td></td>
            <td>Maksymalny udział powierzchni zabudowy [%]</td>
            <td>
              <input
                type="text"
                name={`${udzialZabudowyField}_${index}`}
                style={this.errorStyle(errorState, `${udzialZabudowyField}_${index}`)}
                className="form-control"
                value={this.state[group][index][udzialZabudowyField]}
                onChange={e => this.onIndexedChange(e, group, udzialZabudowyField, index, errorState)}
                placeholder="Maksymalny udział powierzchni zabudowy [%]..."
              />
              {this.renderErrorsInSpan(errorState, `${udzialZabudowyField}_${index}`)}
            </td>
          </tr>,
          <tr key={`${group}${wysZabudowyField}Row_${index}`}>
            <td></td>
            <td>Maksymalna wysokość zabudowy [m]</td>
            <td>
              <input
                type="text"
                name={`${wysZabudowyField}_${index}`}
                style={this.errorStyle(errorState, `${wysZabudowyField}_${index}`)}
                className="form-control"
                value={this.state[group][index][wysZabudowyField]}
                onChange={e => this.onIndexedChange(e, group, wysZabudowyField, index, errorState)}
                placeholder="Maksymalna wysokość zabudowy [m]"
              />
              {this.renderErrorsInSpan(errorState, `${wysZabudowyField}_${index}`)}
            </td>
          </tr>,
          <tr key={`${group}${udzialPowField}Row_${index}`}>
            <td></td>
            <td>Minimalny udział powierzchni biologicznie czynnej [%]</td>
            <td>
              <input
                type="text"
                name={`${udzialPowField}_${index}`}
                style={this.errorStyle(errorState, `${udzialPowField}_${index}`)}
                className="form-control"
                value={this.state[group][index][udzialPowField]}
                onChange={e => this.onIndexedChange(e, group, udzialPowField, index, errorState)}
                placeholder="Minimalny udział powierzchni biologicznie czynnej [%]"
              />
              {this.renderErrorsInSpan(errorState, `${udzialPowField}_${index}`)}
            </td>
          </tr>,
        ])}
        </tbody>
      </table>
    );
  };

  renderErrorsInSpan = (errorsState, errorField) => {
    return (    
      <div>
      {Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
      this.state[errorsState][errorField] !== null &&
      this.state[errorsState][errorField].length > 0
      ? this.state[errorsState][errorField].map((val) => (
        <span key={val} style={errorSpanStyle}>
          {val}
        </span>
      ))
      : null}
    </div>)
  }

  errorStyle = (errorsState, errorField) => (
    {
      width: '100%',
      borderColor:
        Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
          this.state[errorsState][errorField] !== null &&
          this.state[errorsState][errorField].length > 0
          ? 'red'
          : '#ccc',
    }
  )

  renderAgentInfo = () => {
    return (
      <div style={{ textAlign: 'justify' }}>
        <p>
          Zgodnie z Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej w przypadku dodania pełnomocnika do wniosku <b>istnieje obowiązek uiszczenia opłaty skarbowej za złożenie dokumentu stwierdzającego udzielenie pełnomocnictwa.</b> Za każde pełnomocnictwo złożone w urzędzie opłata wynosi 17 zł.
        </p>

        <p style={{ color: 'red' }}>
          Jeśli opłaciłeś opłatę przelewem dodaj potwierdzenie uiszczenia opłaty skarbowej za pełnomocnictwo w sekcji załączników. Możesz również uiścić opłatę w dalszym kroku niniejszej e-usługi poprzez płatność online.
        </p>

        <p>
          <b>Zwalnia się z obowiązku opłaty skarbowej za złożenie dokumentu, który stwierdza udzielenie pełnomocnictwa</b> w przypadku udzielenia pełnomocnictwa żonie, dzieciom, rodzicom, dziadkom, wnukom lub rodzeństwu lub jeśli sprawę załatwia pełnomocnik ustanowiony do kontaktów w ZUS lub pełnomocnik wpisany do CEIDG.
        </p>

        <p style={{ color: 'red' }}>
          W przypadku zwolnienia zaznacz opcję "Zwolniono z opłaty”.
        </p>

        {this.renderCheckbox('pelnomocnik', 'zwolnionoZOplaty', oplataLabel)}
      </div>
    )
  }

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <GrayPanel
          title={'Rodzaj pisma:'}
        >
          {this.renderRadioButtons(rodzajPismaOptions, 'info', 'rodzajPisma')}
        </GrayPanel>
        <GrayPanel
          title={'Rodzaj aktu planowania przestrzennego:'}
        >
          {this.renderRadioButtons(rodzajAktuOptions, 'info', 'rodzajAktu')}
        </GrayPanel>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />

        <GrayPanel
          title={'Adres do korespondencji:'}
        >
          {this.renderCheckbox('adresKorespondencyjny', 'adresKorespondencyjny', korespondencyjnyLabel)}
          {this.state.adresKorespondencyjny.adresKorespondencyjny ?
            <DecisionContainer
              title={'Dane adresowe:'}
              data={this.state.adresKorespondencyjny}
              errors={this.state.errors}
              formDict={korespondencyjnyDict}
              onChange={e => this.onChange(e, 'adresKorespondencyjny')}
            >
            </DecisionContainer>
          : null}
        </GrayPanel>

        <GrayPanel
          title={'Dane pełnomocnika:'}
        >
          {this.renderCheckbox('pelnomocnik', 'pelnomocnik', pelnomocnikLabel)}
          {this.renderCheckbox('pelnomocnik', 'pelnomocnikDoDoreczen', pelnomocnikDoDorLabel)}
          {this.state.pelnomocnik.pelnomocnik || this.state.pelnomocnik.pelnomocnikDoDoreczen ?
            <DecisionContainer
              title={'Dane pełnomocnika:'}
              data={this.state.pelnomocnik}
              errors={this.state.errors}
              formDict={agentDict}
              onChange={e => this.onChange(e, 'pelnomocnik')}
            >
            </DecisionContainer>
          : null}
          {this.state.pelnomocnik.pelnomocnik || this.state.pelnomocnik.pelnomocnikDoDoreczen ?
            this.renderAgentInfo()
          : null}
        </GrayPanel>

        <GrayPanel
          title={'Nieruchomości objęte wnioskiem lub uwagą'}
        >
          <b>Czy składający pismo jest właścicielem lub użytkownikiem wieczystym nieruchomości objętej wnioskiem lub uwagą?</b>
          <div style={{ marginBottom: '20px', marginTop: '20px' }}>
            {this.renderRadioButtons(wlascicielOptions, 'info', 'wlasciciel')}
          </div>
          
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        
        <DecisionContainer
          title={'Treść pisma'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={trescDict}
          onChange={e => this.onChange(e, 'info')}
        >
          {this.renderCheckbox('info', 'documentDetailsVisible', documentDetailsLabel)}
          {this.state.info.documentDetailsVisible ? this.renderDocumentDetails() : null}
          {this.renderCheckbox('info', 'parcelDetailsVisible', parcelDetailsLabel)}
          {this.state.info.parcelDetailsVisible ? this.renderParcelDetails() : null}
        </DecisionContainer>

        <GrayPanel
          title={'Oświadczenie w sprawie korespondencji elektronicznej'}
        >
          {this.renderRadioButtons(korespondencjaElektronicznaOptions, 'info', 'korespondencjaElektroniczna')}
          <p>na doręczanie korespondencji w niniejszej sprawie za pomocą środków komunikacji elektronicznej w rozumieniu art. 2 pkt 5 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (Dz. U. z 2020 r. poz. 344).</p>
        </GrayPanel>

        <SpecifiedAttachmentsPanel attachmentsDict={this.state.attachmentsDict} onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PismoDoAktu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(PismoDoAktu),
);



// WEBPACK FOOTER //
// src/routes/eservices/PismoDoAktu.js